import React from 'react';
import { Flex, Center, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { HelpdeskContactButton } from 'HelpdeskContactButton';

const NotFound = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Center w='100%' h='100%'>
      <Flex
        fontSize='4rem'
        fontWeight='bold'
        align='center'
        justify='center'
        direction='column'
      >
        <Text color='graphite.500'>404</Text>
        <Text fontSize='3rem' mt={2} color='graphite.500'>
          {t('notFound', 'Not found')}
        </Text>
        <Text fontSize='sm' mt={2} color='graphite.500'>
          {t(
            'notFoundHelpdesk',
            'Jeśli potrzebujesz pomocy, skontaktuj się z naszym helpdeskiem:',
          )}
        </Text>
        <HelpdeskContactButton />
      </Flex>
    </Center>
  );
};

export default NotFound;
